import { connectRouter } from 'connected-react-router/immutable';
import { History } from 'history';
import { combineReducers } from 'redux-immutable';
import workQueueReducer from 'containers/WorkQueue/reducer';
import involvedPartiesReducer from 'containers/InvolvedParties/reducer';
import statusHistoryReducer from 'containers/StatusHistory/reducer';
import agreements from 'containers/Agreements/reducer';
import commentsReducer from 'containers/Comments/reducer';
import workList from 'containers/WorkList/reducer';
import scoring from 'containers/Scoring/reducer';
import myWorklist from 'containers/MyWorklist/reducer';

import appReducer from 'containers/App/reducer';

export default (history: History) =>
  combineReducers<any>({
    router: connectRouter(history),
    workQueue: workQueueReducer,
    appReducer,
    involvedParties: involvedPartiesReducer,
    statusHistory: statusHistoryReducer,
    agreements,
    comments: commentsReducer,
    workList,
    scoring,
    myWorklist
  });
